import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Landmark, Lock } from 'lucide-react';
import { fadeInUp, staggerContainer } from '../hooks/useScrollAnimation';

/**
 * This bar previously claimed "Trusted by clubs across Europe" above an empty
 * list, which read as a broken or unearned claim. Until there are named club
 * references cleared for public use, it carries the credentials we can actually
 * stand behind. Swap this for a club logo wall once those are confirmed.
 */
const credentials = [
  {
    icon: Landmark,
    title: 'Issued by licensed partners',
    detail: 'Cards are issued through regulated banking partners, not by ESF.',
  },
  {
    icon: ShieldCheck,
    title: 'Mastercard network',
    detail: 'Accepted anywhere your fans already spend.',
  },
  {
    icon: Lock,
    title: 'GDPR-compliant by design',
    detail: 'Fan data stays inside the EU and stays yours.',
  },
];

const SocialProofBar = () => {
  return (
    <section className="relative py-14 bg-esf-dark border-y border-white/[0.04]">
      <motion.div
        variants={staggerContainer}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-50px' }}
        className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8"
      >
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 sm:gap-6">
          {credentials.map((credential) => (
            <motion.div
              key={credential.title}
              variants={fadeInUp}
              className="flex items-start gap-3 text-left"
            >
              <credential.icon
                size={20}
                className="text-esf-blue flex-shrink-0 mt-0.5"
                aria-hidden="true"
              />
              <div>
                <p className="text-sm font-semibold text-esf-white">{credential.title}</p>
                <p className="mt-1 text-sm text-esf-gray-500 leading-relaxed">
                  {credential.detail}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default SocialProofBar;
